import React, { Component } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Offsidebar from './Offsidebar';
import Footer from './Footer';
import Chatbot from './Chatbot';

class Base extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 0,
      noFooter: this.props.SideBarConfig.module,
      isLoggedIn: this.props.SideBarConfig.isLoggedIn === "true"
    };
  }

  componentDidMount() {
    const { isLoggedIn } = this.props.SideBarConfig;
    this.setState({ isLoggedIn: isLoggedIn === "true" });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      noFooter: nextProps.SideBarConfig.module,
      isLoggedIn: nextProps.SideBarConfig.isLoggedIn === "true"
    });
  }
  render() {
    let { noFooter, isLoggedIn } = this.state;
    return (
      <div className="wrapper">
        <Header
          changeProps={() => { this.setState({ key: Math.random() }); }}
          onLogout={this.props.onLogout}
        />
        <Sidebar style={{ fontSize: "13px" }} _userconfig={{ ...this.props }} />
        <Offsidebar />
        <section className={`${noFooter === "epointAnalytics" ? "seccionNOne" : "section-container"}`} key={this.state.key}>
          {this.props.children}
        </section>

        <Footer _userconfig={{ ...this.props }} />
        {isLoggedIn && <Chatbot />}
      </div>
    );
  }
}

export default Base;
